import { createAsyncThunk } from '@reduxjs/toolkit';
import fetchTrayWizardCode from './fetchTrayWizardCode';
import createTraySolutionInstance from './createTraySolutionInstance';
import { generateTrayWizardUrl, generateNewConnection } from '../../../helpers/connectionManager';
import { selectWorkflowById } from '../selectors';

export default createAsyncThunk('connectionManager/newTrayInstanceWizard', async (payload, { dispatch, getState }) => {
  const { solutionId, accountId, title } = payload;
  const network = selectWorkflowById(solutionId)(getState());

  if (!network) {
    throw new Error('invalid solution id');
  }

  const [{ payload: code }, { payload: instance }] = await Promise.all([
    dispatch(fetchTrayWizardCode()),
    dispatch(
      createTraySolutionInstance({
        accountId,
        solutionId: network.id,
        instanceName: title ?? network.title,
      })
    ),
  ]);

  if (!code || !instance) {
    throw new Error("couldn't create a solution instance");
  }

  const trayWizardUrl = generateTrayWizardUrl(instance.id, code);
  const solutionInstance = generateNewConnection({
    network,
    trayWizardUrl,
    title: instance.name,
    id: instance.id,
    enabled: instance.enabled,
    triggerUrl: instance?.workflows?.edges?.[0]?.node?.triggerUrl,
  });

  return { solutionInstance };
});
